import { useState } from "react";
import { supabase } from "../supabase/supabaseClient";

export default function ResetPasswordRequest() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleReset(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setMsg("");
    setError("");
    if (!email) {
      setError("이메일을 입력해 주세요.");
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password",
    });
    setLoading(false);
    if (error) setError(error.message);
    else setMsg("비밀번호 재설정 링크가 이메일로 전송되었습니다!");
  }

  return (
    <div className="max-w-md mx-auto mt-20 p-8 bg-white rounded-2xl shadow-xl">
      <h2 className="text-2xl font-bold mb-8 text-center">비밀번호 재설정 요청</h2>
      <form onSubmit={handleReset}>
        <label className="block mb-2 font-semibold">가입 이메일 주소</label>
        <input
          type="email"
          className="w-full px-3 py-2 mb-4 border rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="이메일 입력"
        />
        {error && (
          <div className="mb-4 text-red-600 font-semibold text-sm">{error}</div>
        )}
        {msg && (
          <div className="mb-4 text-green-600 font-semibold text-sm">{msg}</div>
        )}
        <button
          type="submit"
          className="w-full bg-black text-white py-2 rounded hover:bg-gray-900 transition disabled:bg-gray-300"
          disabled={loading}
        >
          {loading ? "메일 발송 중..." : "비밀번호 재설정 메일 보내기"}
        </button>
      </form>
    </div>
  );
}
